export default __webpack_public_path__ + "43b6babe514ec723f3893650a4cbbbdc.png";